import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface ActionCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  to: string;
  color?: string;
}
const ActionCard: React.FC<ActionCardProps> = ({
  title,
  description,
  icon,
  to,
  color = 'bg-gradient-to-br from-[#E91E63] to-[#9C27B0]'
}) => {
  return <Link to={to} className={`block rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 ${color} text-white`} data-id="element-29">
      <div className="p-5" data-id="element-30">
        <div className="flex items-center mb-3" data-id="element-31">
          <div className="mr-3 bg-white bg-opacity-20 p-2 rounded-full" data-id="element-32">
            {icon}
          </div>
          <h3 className="font-bold text-lg" data-id="element-33">{title}</h3>
        </div>
        <p className="text-sm opacity-90 mb-4" data-id="element-34">{description}</p>
        <div className="flex justify-end" data-id="element-35">
          <span className="flex items-center text-sm font-medium" data-id="element-36">
            Continuar <ArrowRightIcon size={16} className="ml-1" data-id="element-37" />
          </span>
        </div>
      </div>
    </Link>;
};
export default ActionCard;